import { Link } from 'react-router-dom';

// TODO: 換成你的正式客服電郵
const CONTACT_EMAIL = 'support@fatematch.app';
// TODO: 填上管轄地（例如 香港特別行政區 / 中華民國台灣）
const JURISDICTION = '香港特別行政區';
const UPDATED = '2026年6月15日';

const Section = ({ n, title, children }) => (
  <section className="mb-8">
    <h2 className="text-xl font-serif text-[#1A1A1A] mb-3">{n}. {title}</h2>
    <div className="text-sm leading-relaxed text-[#4A4A4A] space-y-2">{children}</div>
  </section>
);

const Terms = () => (
  <div className="min-h-screen bg-[#FDFBF7] py-12 px-6">
    <div className="max-w-3xl mx-auto">
      <Link to="/" className="text-sm text-[#C93B2B] hover:underline">← 返回首頁</Link>
      <h1 className="text-3xl font-serif text-[#1A1A1A] mt-6 mb-2">服務條款</h1>
      <p className="text-xs text-[#9A9A9A] mb-6">最後更新：{UPDATED}</p>

      <p className="text-sm leading-relaxed text-[#4A4A4A] mb-8">
        歡迎使用命理配對平台（下稱「本平台」）。當你註冊或使用本平台，即表示你同意以下服務條款。
      </p>

      <Section n="1" title="服務說明">
        <p>本平台是一個雙邊中介平台，連接「求測者」與「命理師」。求測者提交求測單，命理師回答驗證問題並開價，求測者比較後可選擇付款解鎖私人諮詢。</p>
      </Section>

      <Section n="2" title="帳號註冊">
        <p>你須以 Google 帳號登入並提供準確資料。你須對自己帳號下的一切活動負責，並妥善保管登入憑證。</p>
      </Section>

      <Section n="3" title="重要免責聲明（命理內容）">
        <p><strong>本平台上的命理、占卜、八字、紫微斗數等意見僅供參考及娛樂用途，並不構成醫療、法律、財務、投資、心理或任何專業建議。</strong>你應自行作出判斷與決定；本平台及命理師對你依賴有關意見所導致的任何後果概不負責。</p>
      </Section>

      <Section n="4" title="平台角色">
        <p>本平台僅為中介，不提供命理服務本身，亦不保證命理師意見的準確性、品質或任何結果。命理師為獨立的服務提供者，與本平台並無僱傭關係。</p>
      </Section>

      <Section n="5" title="用戶守則與禁止行為">
        <p>你不得進行下列行為：詐騙、虛假陳述、騷擾或辱罵、發送垃圾訊息、侵犯他人權利、或任何違法用途。違反者的帳號可被停用、命理師個人頁可被停用，或被永久封禁。用戶可透過平台的舉報機制檢舉違規行為。</p>
      </Section>

      <Section n="6" title="付款與退款">
        <p>選擇命理師並完成付款後，即可解鎖與該命理師的私人諮詢。付款透過第三方付款服務商處理（啟用後）。退款政策將於正式收款功能上線時公布。</p>
      </Section>

      <Section n="7" title="知識產權">
        <p>本平台的內容、商標及介面均屬本平台或其授權人所有。你就提交內容授予本平台為提供服務所需的使用權。</p>
      </Section>

      <Section n="8" title="服務暫停與終止">
        <p>如你違反本條款，我們可暫停或終止你的帳號。你亦可隨時停止使用本平台。</p>
      </Section>

      <Section n="9" title="責任限制">
        <p>在適用法律允許的最大範圍內，本平台對任何間接、附帶、特殊或後果性損害概不負責。</p>
      </Section>

      <Section n="10" title="條款修訂">
        <p>我們可不時修訂本條款。修訂後你繼續使用本平台，即視為接受修訂內容。</p>
      </Section>

      <Section n="11" title="管轄法律">
        <p>本條款受{JURISDICTION}法律管轄，並據其解釋。</p>
      </Section>

      <Section n="12" title="聯絡我們">
        <p>如對本條款有任何疑問，請電郵：<a href={`mailto:${CONTACT_EMAIL}`} className="text-[#C93B2B] hover:underline">{CONTACT_EMAIL}</a></p>
      </Section>
    </div>
  </div>
);

export default Terms;
